import React from "react";
import styled from "styled-components";

const BarOuter = styled.div`
  position: relative;
  height: 4rem;
`;

const Bar = styled.div`
  position: relative;
  width: ${(props) => props.percent}%;
  height: 1.4rem;
  background-color: ${(props) => props.theme.palette.primary};
  border-radius: 0 0.5rem 0.5rem 0;
  transition: width 0.2s ease-out;
`;

const position = (percent) => {
  if (percent < 10) return "100%";
  if (percent > 90) return "0%";
  return "50%";
};

const Text = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  transform: ${(props) => `translateX(${position(props.percent)})`};
  color: ${(props) => props.theme.palette.primary};
  font-size: 2.5rem;
  font-weight: bold;
`;

const ProgressBar = ({ percent }) => {
  return (
    <BarOuter>
      <Bar percent={percent}>
        {percent > 0 && <Text percent={percent}>{percent}%</Text>}
      </Bar>
    </BarOuter>
  );
};

export default ProgressBar;
